import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  DialogContent,
  DialogTitle,
  Dialog,
  Typography
} from '@material-ui/core';
import { updateNextechStatusApi } from '../../api';
import NextechDuplicatedCustomersList from './NextechDuplicatedCustomersList';
import ModMedDuplicatedCustomersList from './ModMedDuplicatedCustomersList';


const ResolveSyncPopup = ({ order, openResolveWindow, setOpenResolveWindow, integration }) => {
  const dispatch = useDispatch();

  const [selectedCustomerId, setSelectedCustomerId] = useState('');

  const {
    entity_id: orderId,
    customer_id: customerId,
    customer_email: email,
    customer_firstname: firstname,
    customer_lastname: lastname,
    store_id: website_id,
    extension_attributes: { emr_sync_error },
    customer_is_guest
  } = order;

  const isModMed = integration === 'modmed';
  const integrationName = isModMed ? 'ModMed' : 'Nextech';

  const customerData = {
    id: customerId,
    email,
    firstname,
    lastname,
    website_id,
    custom_attributes: isModMed ? { modmed_id: selectedCustomerId } : { nextech_id: selectedCustomerId }
  };

  const notAbleToResolve = emr_sync_error === 'duplicated_customer' && customer_is_guest === 1;

  // Resolve reuses the generic customer-update endpoint; only the custom_attributes key differs.
  const updateStatus = async () => {
    const isUpdated = await updateNextechStatusApi({ dispatch, customerId, customerData });

    if (isUpdated) {
      setOpenResolveWindow(false);
    }
  };

  return (
    <>
      <Dialog
        open={openResolveWindow}
        onClose={() => setOpenResolveWindow(false)}
        maxWidth={notAbleToResolve ? 'md' : 'lg'}
        fullWidth
      >
        {!notAbleToResolve &&
        <DialogTitle>
          <Typography variant="h4" className="mt-4">Duplicated Customers List</Typography>
        </DialogTitle>
        }
        <DialogContent  className="m-4">
          {notAbleToResolve ?
            <div className="flex-column items-center">
              <Typography variant="h5" className="mb-6">
                Fix duplicates in {integrationName} to sync this order. Customer - {`[${customerData.firstname} ${customerData.lastname}, ${customerData.email}]`}
              </Typography>
              <Button
                variant="contained"
                onClick={() => setOpenResolveWindow(false)}
              >
                Close
              </Button>
            </div>
            :
            <>
              {isModMed ?
                <ModMedDuplicatedCustomersList
                  orderId={orderId}
                  setSelectedCustomerId={setSelectedCustomerId}
                  selectedCustomerId={selectedCustomerId}
                />
                :
                <NextechDuplicatedCustomersList
                  orderId={orderId}
                  setNextechCustomerId={setSelectedCustomerId}
                  nextechCustomerId={selectedCustomerId}
                />
              }
              <div className="mt-5">
                <Button
                  color="primary"
                  variant="contained"
                  endIcon={<Icon>send</Icon>}
                  className="mr-3"
                  disabled={!selectedCustomerId}
                  onClick={updateStatus}
                >
                  Send
                </Button>
                <Button
                  variant="contained"
                  onClick={() => setOpenResolveWindow(false)}
                >
                  Cancel
                </Button>
              </div>
            </>
          }
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ResolveSyncPopup;
